var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.room.isPlaying)?_c('Game',{attrs:{"game":_vm.room.game,"playerId":'',"userInterfaceType":_vm.room.userInterfaceType,"isGallary":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }